module.exports = __webpack_public_path__ + "assets/4cbb0e9c651ec4347747f98ece988674.mp4";